import { type CompareState } from './state';
import _ from 'lodash';

const addToCompare = (state: CompareState, vehicleId: string) => {
  if (_.includes(state.compareVehicleIds, vehicleId)) {
    return state;
  }

  return _.assign({}, state, {
    compareVehicleIds: _.concat(state.compareVehicleIds, vehicleId),
  });
};

const removeFromCompare = (state: CompareState, vehicleId: string) => {
  return _.assign({}, state, {
    compareVehicleIds: _.without(state.compareVehicleIds, vehicleId),
  });
};

export type RemoveFromCompare = (state: CompareState, vehicleId: string) => CompareState;

export default { addToCompare, removeFromCompare };
